import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { useAvailableActions } from 'modules/expenses/lib/expensables/availableActions'

type OptionsProps = Partial<ReturnType<typeof useAvailableActions>> & {
  onApprove: () => void
  onReject: () => void
  onRestartReview?: () => void
  onAddToPayroll: () => void
  onAddToPayment: () => void
  onRemoveFromPayroll: () => void
  onSetToPaid?: () => void
  onRevertPaid?: () => void
  onAddToGroup: () => void
  onRemoveFromGroup: () => void
}

export const Options = ({
  canReview = false,
  canRestart = false,
  canSetToPaid = false,
  canRevertPaid = false,
  canAddToPayroll = false,
  canAddToPayment = false,
  canRemoveFromPayroll = false,
  canAddToGroup = false,
  canRemoveFromGroup = false,
  onApprove,
  onReject,
  onRestartReview,
  onAddToPayroll,
  onAddToPayment,
  onRemoveFromPayroll,
  onSetToPaid,
  onRevertPaid,
  onAddToGroup,
  onRemoveFromGroup,
}: OptionsProps) => (
  <>
    {canReview && (
      <PopoverMenu.TouchableOption
        title={i18n.t('expenses_v2.list.actions.approve')}
        onClick={onApprove}
      />
    )}
    {canReview && (
      <PopoverMenu.TouchableOption
        title={i18n.t('expenses_v2.list.actions.reject')}
        onClick={onReject}
      />
    )}
    {canRestart && (
      <PopoverMenu.TouchableOption
        title={i18n.t('expenses_v2.list.actions.reset_approval_flow')}
        onClick={onRestartReview}
      />
    )}
    {canAddToPayroll && (
      <PopoverMenu.TouchableOption
        title={i18n.t('expenses_v2.list.actions.reimburse_through_payroll')}
        onClick={onAddToPayroll}
      />
    )}
    {canAddToPayment && (
      <PopoverMenu.TouchableOption
        title={i18n.t('expenses_v2.list.actions.reimburse_through_sepa_file')}
        onClick={onAddToPayment}
      />
    )}
    {canRemoveFromPayroll && (
      <PopoverMenu.TouchableOption
        title={i18n.t('expenses_v2.list.actions.remove_from_payroll')}
        onClick={onRemoveFromPayroll}
      />
    )}
    {canSetToPaid && (
      <PopoverMenu.TouchableOption
        title={i18n.t('expenses_v2.list.actions.set_as_paid')}
        onClick={onSetToPaid}
      />
    )}
    {canRevertPaid && (
      <PopoverMenu.TouchableOption
        title={i18n.t('expenses_v2.buttons.revert_paid')}
        onClick={onRevertPaid}
      />
    )}
    {canAddToGroup && (
      <PopoverMenu.TouchableOption
        title={i18n.t('expenses_v2.buttons.add_to_group')}
        onClick={onAddToGroup}
      />
    )}
    {canRemoveFromGroup && (
      <PopoverMenu.TouchableOption
        title={i18n.t('expenses_v2.buttons.remove_from_group')}
        onClick={onRemoveFromGroup}
      />
    )}
  </>
)
